<div class="fixed inset-0 z-50 flex justify-end" aria-modal="true">
  <!-- Overlay -->
  <div class="absolute inset-0 bg-[#363738] bg-opacity-30 backdrop-blur-lg transition-opacity dark:bg-[#3333331f]"
    (click)="onCloseModal()"></div>

  <!-- Slideout -->
  <div
    class="relative w-full max-w-4xl bg-white dark:bg-zinc-950 shadow-lg border border-zinc-200 dark:border-white/10 flex flex-col rounded-xl overflow-hidden transform transition-all duration-500 ease-out">

    <!-- Header -->
    <div
      class="flex items-center justify-between border-b border-zinc-200 dark:border-white/10 px-6 py-4 bg-zinc-50 dark:bg-zinc-900 rounded-t-xl shadow-md">
      <h3 class="text-xl font-semibold text-main-dark tracking-tight">{{(source | titlecase )|| 'Onboarding'}} Logs</h3>
      <button (click)="onCloseModal()"
        class="rounded-md bg-transparent text-zinc-500 hover:text-zinc-700 dark:text-white dark:hover:text-zinc-300 transition duration-200 focus:outline-none">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Search -->
    <div class="p-4 border-b border-zinc-200 dark:border-white/10 bg-zinc-50 dark:bg-zinc-900">
      <div class="relative w-full">
        <input [(ngModel)]="search" type="text" placeholder="Search logs..."
          class="pl-10 w-full border border-zinc-300 rounded-md py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary dark:bg-zinc-800 dark:text-white transition duration-200 shadow-lg focus:ring-opacity-60" />
        <svg xmlns="http://www.w3.org/2000/svg" class="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-zinc-500"
          viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
      </div>
    </div>

    <!-- Logs -->
    <div class="flex-1 overflow-y-auto p-4 space-y-4">
      <ul role="list" class="space-y-4">
        <li *ngFor="let log of logsList | filter:search; let i = index"
          class="p-4 border border-zinc-200 dark:border-white/10 rounded-lg bg-white dark:bg-zinc-900 shadow-md hover:shadow-xl  transform transition-all duration-300 ease-out">
          <!-- Header -->
          <div class="flex justify-between items-start space-x-4">
            <div>
              <div class="font-semibold text-sm text-main-dark tracking-tight">
                {{ log.message }}
                <span class="text-xs text-gray-600">{{ (log.type | titlecase) + '-' + (i + 1) }}</span>
              </div>
              <p class="text-xs text-main-secondary mt-1">{{ log.time | date:'MM/DD/YYYY HHmm' }}</p>
            </div>
            <span *ngIf="log.user && preUsers && preUsers[log.user]"
              class="px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">
              {{ preUsers[log.user].name | titlecase }}
            </span>
          </div>

          <!-- Log Content -->
          <div class="relative overflow-hidden transition-all duration-500 ease-out" [ngClass]="{
                 'max-h-20': !expandedLogs[i], 
                 'max-h-[none]': expandedLogs[i]
               }">
            <!-- Changes -->
            <div *ngIf="log.changes" class="mt-3 space-y-2 text-xs text-zinc-700 dark:text-zinc-300">
              <ng-container *ngTemplateOutlet="renderChanges; context: { $implicit: log.changes, level: 0 }">
              </ng-container>
            </div>

            <!-- Fade effect -->
            <div *ngIf="!expandedLogs[i]"
              class="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-white dark:from-zinc-900 to-transparent">
            </div>
          </div>

          <!-- Show More / Show Less -->
          <div class="flex justify-end">
            <button class="badge-primary m-0.5 dark:badge-secondary text-xs underline mt-1" (click)="toggleExpand(i)">
              {{ expandedLogs[i] ? 'Show Less' : 'Show More' }}
            </button>
          </div>
        </li>
      </ul>

      <!-- Empty State -->
      <div *ngIf="!logsList?.length"
        class="flex flex-col items-center justify-center h-72 text-center text-sm text-zinc-500 dark:text-zinc-400">
        <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-12 w-12 mb-3 text-zinc-400 dark:text-zinc-600"
          fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M3 8.25V18a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 18V8.25M3 8.25V6A2.25 2.25 0 015.25 3.75h13.5A2.25 2.25 0 0121 6v2.25M3 8.25h18" />
        </svg>
        <p class="font-medium">No {{source | titlecase}} Logs To Show</p>
      </div>
    </div>
  </div>

  <!-- Recursive Template -->
  <ng-template #renderChanges let-data let-level="level">
    <div *ngFor="let key of objectKeys(data)" [style.marginLeft.px]="level * 16" class="flex flex-col gap-1">

      <div *ngIf="isArray(data[key])" class="flex flex-col gap-1">
        <span class="font-semibold text-main-dark capitalize">{{ key }}:</span>

        <div *ngFor="let item of data[key]; let i = index" [style.marginLeft.px]="(level + 1) * 16">

          <ng-container *ngIf="isObject(item); else arraySimple">
            <ng-container
              *ngTemplateOutlet="renderChanges; context: { $implicit: item, level: level + 2 }"></ng-container>
          </ng-container>

          <ng-template #arraySimple>
            <span class="px-2 py-0.5 rounded-md bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-200">
              {{ formatDate(item) }}
            </span>
          </ng-template>

        </div>
      </div>

      <div *ngIf="isObject(data[key]) && !isArray(data[key])" class="flex flex-col gap-1">
        <span class="font-semibold text-main-dark capitalize">{{ key }}:</span>
        <ng-container
          *ngTemplateOutlet="renderChanges; context: { $implicit: data[key], level: level + 1 }"></ng-container>
      </div>

      <div *ngIf="!isObject(data[key]) && !isArray(data[key])" class="flex items-center gap-2">
        <span class="font-medium text-main-dark capitalize">{{ key }}:</span>
        <span class="px-2 py-0.5 rounded-md bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-200">
          {{ formatDate(data[key]) }}
        </span>
      </div>

    </div>
  </ng-template>
</div>